const qdAminCommon = window.QD_ADMIN_COMMON || {};
const { envConfig, LoginCommon } = qdAminCommon;
const { protocolDomain = {} } = LoginCommon || {};
const { isPrivate } = envConfig || {};

export { isPrivate, envConfig, protocolDomain };
